import TextCell from 'components/TextCell';
import PropTypes from 'prop-types';
import { stringifyLocationSearch } from 'hooks/useStorage/utils';
import { useManagementPageContext } from 'pages/Management/contexts/ManagementPageContext';
import LinkTo from 'components/LinkTo';

export default function CountCell({ count, pageParams }) {
  const { setPageParams } = useManagementPageContext();
  const url = `/management${stringifyLocationSearch({
    tab: pageParams.tab,
    oemSegmentIds: pageParams.oemSegmentIds,
    teamIds: pageParams.teamIds,
    accountIds: pageParams.accountIds,
  })}`;

  const handleClick = () => {
    setPageParams(pageParams);
  };

  if (count) {
    return (
      <LinkTo to={url} onClick={handleClick}>
        {count}
      </LinkTo>
    );
  }

  return <TextCell text={String(count)} />;
}

CountCell.propTypes = {
  count: PropTypes.number,
  pageParams: PropTypes.shape({
    tab: PropTypes.string,
    oemSegmentIds: PropTypes.arrayOf(PropTypes.string),
    teamIds: PropTypes.arrayOf(PropTypes.string),
    accountIds: PropTypes.arrayOf(PropTypes.string),
    depotIds: PropTypes.arrayOf(PropTypes.string),
  }),
};

CountCell.defaultProps = {
  count: 0,
  pageParams: {
    tab: 'oem-segments',
    oemSegmentIds: [],
    teamIds: [],
    accountIds: [],
    depotIds: [],
  },
};
